import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetCar/Main";
import Form from "./TbSetCar/Form";

// Utils
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataEmployee } from "../../../model/InitialData/InitialDataEmployee";

const TbSetCar = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataEmpPosition, setDataEmpPosition] = useState([]);
  const [dataEmpDept, setDataEmpDept] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataEmployee());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_Employee ทั้งหมด
      const masterList = await getDataWithComp("Tb_Set_Car", "Order By Car_id");

      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      Car_id: item.Car_id,
      Car_No: item.Car_No,
      Car_Name: item.Car_Name,
      Car_Status: item.Car_Status,
      comp_id: item.Comp_Id,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <div style={{ display: mode === "S" ? "block" : "none" }}>
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลรถ"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              </div>
              <div style={{ display: mode !== "S" ? "block" : "none" }}>
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลรถ"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataEmpPosition={dataEmpPosition}
                  dataEmpDept={dataEmpDept}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetCar;
